{
  "title": "Aktivitätsfilter",
  "tooltip": "Diese Filter schließen FBOs und Benutzer von Aktivitätsberichten und Metriken aus.",
  "unknown": "Unbekannt",
  "testFBOs": {
    "sectionTitle": "Test-/Demo-FBOs",
    "addButton": "FBO hinzufügen",
    "columns": {
      "fboName": "FBO-Name",
      "reason": "Grund",
      "actions": "Aktionen"
    },
    "deleteButton": "Löschen",
    "dialog": {
      "title": "Hinzufügen Test/Demo FBO",
      "selectFboLabel": "FBO auswählen",
      "reasonLabel": "Grund (optional)",
      "reasonPlaceholder": "z. B. Internes Testkonto",
      "cancelButton": "Abbrechen",
      "addButton": "Neu"
    }
  },
  "employees": {
    "sectionTitle": "AirPlx-Mitarbeiter",
    "addButton": "Hinzufügen",
    "autoExcludedChip": "*@airplx.com (auto-ausgeschl.)",
    "emptyState": "Keine zusätzlichen Mitarbeiter konfiguriert (alle @airplx.com E-Mails werden automatisch ausgeschlossen)",
    "dialog": {
      "title": "AirPlx-Mitarbeiter anlegen",
      "emailLabel": "E-Mail-Adresse",
      "emailPlaceholder": "user@example.com",
      "cancelButton": "Abbrechen",
      "addButton": "Neu"
    }
  }
}
